import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\"><path d=\"M702.6312 520.098445 356.711749 170.45723 321.103764 205.930139 634.023636 517.722328 321.63179 813.354466 357.135398 848.729138 669.533384 553.097 669.455613 553.108257Z\" p-id=\"6103\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol